import React from 'react'
import { useEffect } from 'react'
import './scrollup.css'
const Scrollup = () => {


    useEffect(() => {
       const handleScroll=()=>{
        const scrollElement = document.querySelector('.scrollup');
        if(window.scrollY>window.innerHeight/2){ 
            scrollElement.classList.add('showScroll')
        }else{
            scrollElement.classList.remove('showScroll')
        }
       }
      window.addEventListener('scroll', handleScroll)
    
      return () => {
        window.removeEventListener('scroll', handleScroll)
    }
    }, )
    
    
  return (
    <a href="#" className="scrollup ">
        <i className="uil uil-arrow-up scrollup__icon"></i>
    </a>
    )
} 

export default Scrollup